<template>
  <v-dialog v-model="dialog" width="1000" persistent scrollable>
    <template v-slot:activator="{ on }" v-if="icon">
      <v-btn icon color="blue" v-on="on">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <v-card v-if="conteggio != null">
      <v-card-title class="grey--text text-subtitle-1">
        Dettaglio Conteggio
        <template v-if="!loading_conteggio">
          <template v-if="conteggio.tipo == 1">
            <v-btn outlined color="blue" class="ml-4" @click="view = 0"
              ><v-icon class="mr-2">mdi-clipboard</v-icon> Lista</v-btn
            >
            <v-btn outlined color="purple" class="ml-4" @click="view = 1"
              ><v-icon class="mr-2">mdi-cart</v-icon> Carrelli</v-btn
            >
          </template>
        </template>

        <v-spacer />
        <template v-if="integrità != null">
          <span style="font-size: 14px">
            Integrità {{ integrità.valore.toFixed(0) }} %
          </span>
          <v-icon
            size="15"
            class="ml-4"
            :color="integrità.ultimo ? 'green' : 'blue'"
            >mdi-circle</v-icon
          >
        </template>
      </v-card-title>
      <v-card-subtitle class="mt-0">
        <template v-if="ordine != null && !loading_conteggio">
          Ordine # {{ ordine.numero }}
          <br />
        </template>
        Cliente: <b>{{ cliente.nome }}</b>
        <br />
        Stato:
        <span
          :class="
            conteggio.id_contabile
              ? 'purple--text'
              : conteggio.confermato
              ? 'green--text'
              : 'amber--text'
          "
          >{{
            conteggio.id_contabile
              ? "Contabilizzato"
              : conteggio.confermato
              ? "Confermato"
              : "In Corso"
          }}</span
        >
        <br />
        Tipo:
        <span :class="conteggio.tipo == 1 ? 'blue--text' : 'purple--text'"
          >{{ conteggio.tipo == 1 ? "Carrello" : "Lista" }}
        </span>
        <br/>
        Contato da: {{ creatore}}
      </v-card-subtitle>
      <template v-if="loading_conteggio">
        <v-card-text>
          <v-row justify="center" class="my-8">
            <v-progress-circular indeterminate width="2"></v-progress-circular>
          </v-row>
        </v-card-text>
      </template>
      <template v-else>
        <v-card-text v-if="conteggio != 'DoesNotExist'">
          <template v-if="view == 0">
            <v-row no-gutters class="mt-4">
              <v-col cols="4">Prodotto</v-col>

              <v-col v-if="ordine" cols="2">Quantità in Ordine</v-col>
              <v-col v-else cols="2"></v-col>
              <v-col cols="2">Quantità Contata</v-col>
              <v-col v-if="ordine" cols="2" class="d-flex justify-center"
                >Discrepanza</v-col
              >
              <v-col v-else cols="2"></v-col>
            </v-row>
            <v-divider class="mt-2" />
            <template v-if="lista_combinata.length > 0">
              <ConteggioDettaglioEl
                v-for="prodotto in lista_combinata"
                :key="prodotto.id_prodotto"
                :ordine="ordine"
                :prodotto="prodotto"
                :listino="listino"
              />
            </template>
            <template v-else>
              <v-row justify="center" class="my-8">
                Nessun prodotto nel conteggio.
              </v-row>
            </template>
            <v-divider class="my-2" />
            <template v-if="ordine">
              <v-row no-gutters align="center">
                <v-col cols="4"></v-col>

                <v-col cols="2">{{ totale_ordinato.toFixed(2) }} €</v-col>
                <v-col cols="2">{{ totale_contato.toFixed(2) }} €</v-col>
                <v-col cols="2">
                  <v-list-item class="">
                    <v-list-item-avatar>
                      <v-icon size="" :color="totale_discrepanza.color">
                        {{ totale_discrepanza.icon }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ totale_discrepanza.tot.toFixed(2) }} €
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-divider class="mb-6" />
            </template>

            <v-row align="center" no-gutters>
              <v-col cols="6"></v-col>
              <v-col cols="2">Tot Contato:</v-col>
              <v-col cols="4"
                >{{ totale_contato.toFixed(2) }} € + IVA ({{
                  tot_iva_contato.toFixed(2)
                }}
                €)</v-col
              >
            </v-row>
            <v-row v-if="ordine" align="center" no-gutters>
              <v-col cols="6"></v-col>
              <v-col cols="2">Trasporto:</v-col>
              <v-col cols="4"
                >{{ tot_trasporto.toFixed(2) }} € + IVA ({{
                  tot_iva_trasporto.toFixed(2)
                }}
                €)</v-col
              >
            </v-row>
            <v-row align="center" class="font-weight-bold" no-gutters>
              <v-col cols="6"></v-col>
              <v-col cols="2">Tot Documento:</v-col>
              <v-col cols="4"
                >{{ (totale_contato + tot_trasporto).toFixed(2) }} € + IVA ({{
                  (tot_iva_contato + tot_iva_trasporto).toFixed(2)
                }}
                €)</v-col
              >
            </v-row>
          </template>
          <template v-else>
            <v-row class="">
              <v-col cols="4">
                <v-row
                  v-if="conteggio.carrelli.length == 0"
                  class="my-4"
                  justify="center"
                >
                  Nessun carrello nel conteggio.
                </v-row>
                <template v-else>
                  <v-list v-if="carrelli_stesso_subconteggio.length === 0">
                    <v-list-item
                      v-for="carrello in conteggio.carrelli"
                      :key="carrello.id_carrello"
                      @click="
                        put_product({
                          carrello: carrello,
                          id_carrello: carrello.id_carrello,
                        })
                      "
                      :class="
                        selected_cart.id == carrello.id_carrello
                          ? 'grey lighten-4'
                          : ''
                      "
                    >
                      <v-list-item-avatar>
                        <v-icon color="blue">mdi-cart</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          Carrello # {{ carrello.numero }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span v-if="carrello.evaso">Già evaso</span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle> </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <template v-else>
                    <v-card
                      outlined
                      v-for="(
                        gruppo_carrelli, index
                      ) in carrelli_stesso_subconteggio"
                      :key="gruppo_carrelli.id_subconteggio"
                      class="mb-4"
                    >
                      <div class="ml-4 mt-1">
                        {{
                          gruppo_carrelli.id_subconteggio
                            ? "Subconteggio # " + (index + 1)
                            : "Nessun Subconteggio"
                        }}
                      </div>
                      <v-list>
                        <v-list-item
                          v-for="carrello in gruppo_carrelli.carrelli"
                          :key="carrello.id_carrello"
                          @click="
                            put_product({
                              carrello: carrello,
                              id_carrello: carrello.id_carrello,
                            })
                          "
                          :class="
                            selected_cart.id == carrello.id_carrello
                              ? 'grey lighten-4'
                              : ''
                          "
                        >
                          <v-list-item-avatar>
                            <v-icon color="blue">mdi-cart</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              Carrello # {{ carrello.numero }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span v-if="carrello.evaso">Già evaso</span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle> </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </template>
                </template>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="6">
                <v-list>
                  <ProdottoCarrelloElement
                    v-for="prodotto in selected_cart.prodotti"
                    :prodotto="prodotto"
                    :listino="listino"
                    :key="prodotto.id"
                  />
                </v-list>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-text v-else> Nessun conteggio </v-card-text>
      </template>

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          :disabled="!conteggio.confermato || conteggio.id_contabile"
          color="purple"
          @click="crea_contabile()"
          ><v-icon class="mr-2">mdi-cash</v-icon>Crea Contabile</v-btn
        >
        <NuovaContabile
          :ordine_prop="ordine ? ordine.numero.toString() : ''"
          :ordine_id_prop="ordine ? ordine._id.$oid : ''"
          :conteggio_prop="conteggio.id"
          :cliente_prop="cliente.iva"
          :totale_documento="totale_contato"
          :tot_iva_documento="tot_iva_documento"
          :tot_trasporto_documento="tot_trasporto"
          :tot_iva_trasporto_documento="tot_iva_trasporto"
          ref="nuova_contabile"
          @new_insert="archivia_conteggio()"
          noButton
        />
        <v-btn text color="grey" @click="dialog = false">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConteggioDettaglioEl from "./conteggio_dettaglio_element.vue";
import conteggio_dettaglio_mixin from "../../mixin/conteggio_dettaglio_mixin";
import ProdottoCarrelloElement from "./conteggio_prodotto_carrello_element.vue";
import NuovaContabile from "../../../Contabili/desktop/nuova_contabile.vue";
export default {
  components: {
    ConteggioDettaglioEl,
    ProdottoCarrelloElement,
    NuovaContabile,
  },
  mixins: [conteggio_dettaglio_mixin],
};
</script>